import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "dump",
    description: "Dumps command output to file",
    options: [],
    arguments: [],
    callback: function (writer) {
        const dumpedHtml = writer.dump();

        const blob = new Blob([dumpedHtml], { type: "application/html" });
        const fileName = "consoleWindowDump.html";

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            // for IE
            (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
        } else {
            const blobUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.download = fileName;
            anchor.href = blobUrl;
            anchor.click();

            URL.revokeObjectURL(blobUrl);
            anchor.remove();
        }

        return { input: "" };
    }
} as ICLICommand;
